import { render } from "./NPSBreakdown.vue?vue&type=template&id=078187f4&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./NPSBreakdown.vue?vue&type=script&lang=js"
export * from "./NPSBreakdown.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__